<template>
  <div>
    <!-- Consignment Order Details Header -->
    <a-card style="margin-bottom: 24px; border-radius: 8px;">
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <div>
          <h2 style="font-size: 20px; font-weight: bolder;">Consignment Order Details</h2>
          <div style="color: #6B7280; font-size: 15px; max-width: 70%;">
            Review all batch details before finalizing your consignment. Ensure accuracy in batch numbers, expiry dates, and unit quantities before submission.
          </div>
        </div>
        <a-button type="default" style="border: 1px solid #26A246; color: #26A246;">Export Summary Report</a-button>
      </div>
    </a-card>

    <!-- Consignment Overview -->
    <a-card style="margin-bottom: 24px; border-radius: 8px;">
      <h3 style="font-size: 18px; font-weight: bolder;">Consignment Overview</h3>
      <a-row gutter="16">
        <a-col :span="6">
          <div class="label">Consignment ID</div>
          <div class="value">{{ consignment.consignmentId || 'N/A' }}</div>
        </a-col>
        <a-col :span="6">
          <div class="label">Warehouse Location</div>
          <div class="value" style="font-weight: bold;">{{ consignment.warehouse || 'N/A' }}</div>
        </a-col>
        <a-col :span="6">
          <div class="label">Date Sent</div>
          <div class="value">{{ formatDate(consignment.delvieryDate) }}</div>
        </a-col>
        <a-col :span="6">
          <div class="label">Status</div>
          <a-tag color="orange">{{ consignment.status || 'Pending' }}</a-tag>
        </a-col>
        
      </a-row>

      <a-row :gutter="16" style="margin-top: 16px;">
        <a-col :span="6">
          <div class="label">Total Stock</div>
          <div class="value">
            {{ consignment.totalQuantity !== null && consignment.totalQuantity !== undefined ? consignment.totalQuantity + ' Doses' : 'N/A' }}
          </div>
        </a-col>
        <a-col :span="6">
          <div class="label">Stock Sold</div>
          <div class="value">
            {{ consignment.stockSold !== null && consignment.stockSold !== undefined ? consignment.stockSold + ' Doses' : 'N/A' }}
          </div>
        </a-col>
        <a-col :span="6">
          <div class="label">Remaining Stock</div>
          <div class="value">
            {{ consignment.availableStock !== null && consignment.availableStock !== undefined ? consignment.availableStock + ' Doses' : 'N/A' }}
          </div>
        </a-col>
        <a-col :span="6">
          <div class="label">Payout Progress</div>
          <div class="value" style="color: #26A246;">{{ formatAmount(consignment.totalValue) }} Pending</div>
        </a-col>
        </a-row>
    </a-card>

    <!-- Batch Breakdown & Tracking -->
    <a-card style="border-radius: 8px; margin-bottom: 24px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h3 style="font-size: 18px; font-weight: bolder;">Batch Breakdown & Tracking</h3>
        <a-button type="link" style="color: #26A246;">View Batch History</a-button>
      </div>
      <a-table
        :columns="batchColumns"
        :data-source="consignment.batchOrders || []"
        :pagination="false"
        bordered
        rowKey="batchNumber"
        :scroll="{ x: 'max-content' }"
      />
    </a-card>
    <a-button style="margin-top: 24px;" @click="goBack">Back</a-button>
  </div>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import { formatAmount } from '../../utils';

export default {
  name: 'ConsignmentOrderDetails',
  props: {
    userId: { type: String, required: true },
    consignmentId: { type: String, required: true },
  },
  data() {
    return {
      consignment: {},
      batchColumns: [
        { title: 'Batch Number', dataIndex: 'batchNumber', key: 'batchNumber' },
        { title: 'Product Name', dataIndex: 'productName', key: 'productName' },
        { title: 'Manufacture Date', dataIndex: 'manufactureDate', key: 'manufactureDate', customRender: (text) => this.formatDate(text) },
        { title: 'Expiry Date', dataIndex: 'expiryDate', key: 'expiryDate', customRender: (text) => this.formatDate(text) },
        { title: 'Stock Sent', dataIndex: 'unitQuantity', key: 'unitQuantity', customRender: (text) => text + ' Units' },
        { title: 'Stock Remaining', dataIndex: 'remainingStock', key: 'remainingStock', customRender: (text) => text + ' Units' },
        { title: 'Status', dataIndex: 'status', key: 'status', customRender: (text) => this.renderStatusTag(text) },
        { title: 'Actions', key: 'actions', customRender: () => <a-icon type='eye' /> },
      ],
    };
  },
  mounted() {
    this.fetchConsignment();
  },
  methods: {
    formatAmount,
    async fetchConsignment() {
      try {
        const token = Cookies.get('authToken');
        const apiUrl = process.env.VUE_APP_ZHULIA_SELLER_CENTER_URL;
        const response = await axios.get(
          `${apiUrl}/AdminSellerStockMangement/get-consignment/${this.userId}/${this.consignmentId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data && response.data.data) {
          this.consignment = response.data.data;
        }
      } catch (error) {
        this.$message.error('Failed to fetch consignment details.');
      }
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    renderStatusTag(status) {
      let color = 'default';
      if (status === 'Active') color = 'green';
      else if (status === 'Low Stock') color = 'orange';
      else if (status === 'Healthy') color = 'blue';
      return <a-tag color={color}>{status}</a-tag>;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 13px;
  color: #6B7280;
  font-weight: 500;
}
.value {
  font-size: 16px;
  color: #222;
  font-weight: 600;
}
</style> 